
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/remindpass",
      function () {
        return require("private-next-pages/remindpass/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/remindpass"])
      });
    }
  